import React from "react";
import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  let year = new Date().getFullYear();

  return (
    <div
      style={{
        backgroundColor: "##22133a",
        color: "white",
        textAlign: "center",
        padding: "15px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <p style={{ marginBottom: "10px", fontSize: "16px" }}>© {year} Koustav Moitra</p>
      <div style={{ display: "flex", gap: "20px" }}>
        <a
          href="https://github.com/koustavmoitra"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "white", fontSize: "24px" }}
        >
          <AiFillGithub />
        </a>

        <a
          href="https://www.linkedin.com/in/koustav-moitra/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "white", fontSize: "24px"}}

        >
          <FaLinkedinIn />
        </a>


        <a
          href="https://www.instagram.com/koustavmoitra12321/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "white", fontSize: "24px"}}
        >
          <AiFillInstagram />
        </a>
      </div>
    </div>
  );
}

export default Footer;
